export interface SchoolDirectoryEntry {
  district: string;
  udiseCode: string;
  schoolName: string;
}

export const schoolDirectory: SchoolDirectoryEntry[] = [
  { district: "ALMORA", udiseCode: "5090615301", schoolName: "G.G.I.C. ALMORA" },
  { district: "ALMORA", udiseCode: "5090104506", schoolName: "G.G.I.C. BARECHHINA" },
  { district: "ALMORA", udiseCode: "5090711406", schoolName: "G.G.I.C. JAINTI" },
  { district: "ALMORA", udiseCode: "5090402703", schoolName: "G.G.I.C.DWRAHAT" },
  { district: "ALMORA", udiseCode: "5090614701", schoolName: "G.I.C. ALMORA" },
  { district: "ALMORA", udiseCode: "5090813002", schoolName: "G.I.C. BHAUNKHAL" },
  { district: "ALMORA", udiseCode: "5091110703", schoolName: "G.I.C. BHUJAN" },
  { district: "ALMORA", udiseCode: "5090902403", schoolName: "G.I.C. CHINTOLI" },
  { district: "ALMORA", udiseCode: "5090400701", schoolName: "G.I.C. DWARAHAT" },
  { district: "ALMORA", udiseCode: "5090520102", schoolName: "G.I.C. GARURABANJ" },
  { district: "ALMORA", udiseCode: "5090602004", schoolName: "G.I.C. HAWALBAG" },
  { district: "ALMORA", udiseCode: "5091105902", schoolName: "G.I.C. JAINOLI" },
  { district: "ALMORA", udiseCode: "5090910802", schoolName: "G.I.C. KULANTESHWAR" },
  { district: "ALMORA", udiseCode: "5091012601", schoolName: "G.I.C. MANSARINALACHAURA" },
  { district: "ALMORA", udiseCode: "5090308402", schoolName: "G.I.C. PATALGAON" },
  { district: "ALMORA", udiseCode: "5091004501", schoolName: "G.I.C. SALAOJ" },
  { district: "BAGESHWAR", udiseCode: "5080202707", schoolName: "G.I.C. KAPKOT" },
  { district: "BAGESHWAR", udiseCode: "5080305602", schoolName: "G.I.C.AMSYARI" },
  { district: "BAGESHWAR", udiseCode: "5080212803", schoolName: "GIC BADIAKOT" },
  { district: "BAGESHWAR", udiseCode: "5080121901", schoolName: "GIC BHATTKHOLA" },
  { district: "BAGESHWAR", udiseCode: "5080303202", schoolName: "GIC GARUR" },
  { district: "BAGESHWAR", udiseCode: "5080107902", schoolName: "J.S.M.S. G.I.C. KANDA" },
  { district: "BAGESHWAR", udiseCode: "5080100404", schoolName: "S.S.S.S.L.V .G.G.I.C. BAGESHWAR" },
  { district: "CHAMOLI", udiseCode: "5020413913", schoolName: "G.G.I.C. GOUCHAR" },
  { district: "CHAMOLI", udiseCode: "5020413912", schoolName: "G.I.C. GOUCHAR" },
  { district: "CHAMOLI", udiseCode: "5020108003", schoolName: "GGIC JOSHIMATH" },
  { district: "CHAMOLI", udiseCode: "5020302303", schoolName: "GIC BAIRASKUND" },
  { district: "CHAMOLI", udiseCode: "5020903505", schoolName: "GIC DEWAL" },
  { district: "CHAMOLI", udiseCode: "5020209202", schoolName: "GIC GADORA" },
  { district: "CHAMOLI", udiseCode: "5020306602", schoolName: "GIC GHAT" },
  { district: "CHAMOLI", udiseCode: "5020213102", schoolName: "GIC GHINGRANA" },
  { district: "CHAMOLI", udiseCode: "5020203304", schoolName: "GIC GOPESHWAR" },
  { district: "CHAMOLI", udiseCode: "5020201603", schoolName: "GIC GWAR DEWALDHAR" },
  { district: "CHAMOLI", udiseCode: "5020808801", schoolName: "GIC LOLTI" },
  { district: "CHAMOLI", udiseCode: "5020620504", schoolName: "GIC NANDASAIN" },
  { district: "CHAMOLI", udiseCode: "5020210503", schoolName: "GIC PIPALKOTI" },
  { district: "CHAMOLI", udiseCode: "5020101703", schoolName: "GIC TAPOVAN" },
  { district: "CHAMOLI", udiseCode: "5020505806", schoolName: "GMIC NAGNATH POKHARI" },
  { district: "CHAMPAWAT", udiseCode: "5100304701", schoolName: "G I C PATI" },
  { district: "CHAMPAWAT", udiseCode: "5100305001", schoolName: "GGIC CHAMPAWAT" },
  { district: "CHAMPAWAT", udiseCode: "5100210501", schoolName: "GGIC LOHAGHAT" },
  { district: "CHAMPAWAT", udiseCode: "5100209404", schoolName: "GIC  BRP LOHAGHAT" },
  { district: "CHAMPAWAT", udiseCode: "5100304701", schoolName: "GIC CHAMPAWAT" },
  { district: "CHAMPAWAT", udiseCode: "5100403006", schoolName: "GIC MULAKOT" },
  { district: "CHAMPAWAT", udiseCode: "5100305102", schoolName: "GIC TAMLI" },
  { district: "DEHRADUN", udiseCode: "5050201208", schoolName: "ATAL UTKRISHT GOVT. INTER COLLEGE KALSI" },
  { district: "DEHRADUN", udiseCode: "5050530546", schoolName: "GOVT GIRLS INTER COLLEGE RAJPUR ROAD" },
  { district: "DEHRADUN", udiseCode: "5050101406", schoolName: "GOVT INTER COLLEGE BHATAD" },
  { district: "DEHRADUN", udiseCode: "5050301302", schoolName: "GOVT INTER COLLEGE BHIMAWALA" },
  { district: "DEHRADUN", udiseCode: "5050507702", schoolName: "GOVT INTER COLLEGE MALDEVTA" },
  { district: "DEHRADUN", udiseCode: "5050601403", schoolName: "GOVT. INTER COLLEGE DUDHLI" },
  { district: "DEHRADUN", udiseCode: "5050308501", schoolName: "GOVT. INTER COLLEGE HERBARTPUR" },
  { district: "DEHRADUN", udiseCode: "5050619903", schoolName: "GOVT. INTER COLLEGE IDPL VEERBHADRA" },
  { district: "DEHRADUN", udiseCode: "5050519905", schoolName: "RAJIV GANDJI NAVODYA VIDAYLAYA" },
  { district: "HARIDWAR", udiseCode: "5130712104", schoolName: "G.G.H.S. LANDHORA" },
  { district: "HARIDWAR", udiseCode: "5130805309", schoolName: "G.G.I.C. BHAURI." },
  { district: "HARIDWAR", udiseCode: "5130114913", schoolName: "G.G.I.C. JWALAPUR" },
  { district: "HARIDWAR", udiseCode: "5130401402", schoolName: "G.H.S. GORDHANPUR" },
  { district: "HARIDWAR", udiseCode: "5130712701", schoolName: "G.H.S. KILA MANGLOUR" },
  { district: "HARIDWAR", udiseCode: "5130700902", schoolName: "G.I.C  LATHARDEVA HOON" },
  { district: "HARIDWAR", udiseCode: "5130511202", schoolName: "G.I.C. BHOGPUR" },
  { district: "HARIDWAR", udiseCode: "5130801406", schoolName: "G.I.C. IMLIKHERA" },
  { district: "HARIDWAR", udiseCode: "5130206906", schoolName: "G.I.C. KUNJA BAHADURPUR" },
  { district: "HARIDWAR", udiseCode: "5130108404", schoolName: "G.I.C. LALDHANG" },
  { district: "HARIDWAR", udiseCode: "5130506406", schoolName: "G.I.C. MUNDAKHERHA KALA" },
  { district: "HARIDWAR", udiseCode: "5130814101", schoolName: "G.I.C. ROORKEE" },
  { district: "HARIDWAR", udiseCode: "5130205903", schoolName: "G.I.C. SIKANDERPUR BHAINSWAL" },
  { district: "HARIDWAR", udiseCode: "5130713006", schoolName: "SARASHWATI GOVT GIRLS INTER COLLEGE" },
  { district: "NAINITAL", udiseCode: "5110500105", schoolName: "ATAL UTKRISHT GIC KALADHUNGI" },
  { district: "NAINITAL", udiseCode: "5110401101", schoolName: "GGIC DAULIYA" },
  { district: "NAINITAL", udiseCode: "5110404286", schoolName: "GGIC HALDWANI" },
  { district: "NAINITAL", udiseCode: "5110504504", schoolName: "GGIC KOTABAGH" },
  { district: "NAINITAL", udiseCode: "5110107702", schoolName: "GGIC MALDHANCHOUR" },
  { district: "NAINITAL", udiseCode: "5110200401", schoolName: "GHS REETHA" },
  { district: "NAINITAL", udiseCode: "5110211901", schoolName: "GIC DHOKANE" },
  { district: "NAINITAL", udiseCode: "5110706601", schoolName: "GIC KASIYALEKH" },
  { district: "NAINITAL", udiseCode: "5110420101", schoolName: "GIC NARAYAN NAGAR" },
  { district: "NAINITAL", udiseCode: "5110111205", schoolName: "GIC RAMNAGAR" },
  { district: "NAINITAL", udiseCode: "5110112002", schoolName: "GIC THARI" },
  { district: "NAINITAL", udiseCode: "5110504503", schoolName: "GMIC KOTABAGH" },
  { district: "NAINITAL", udiseCode: "5110609602", schoolName: "GMIC PATLOT" },
  { district: "PAURI GARHWAL", udiseCode: "5060814802", schoolName: "GOVT. GIRLS INTER COLLEGE KOTDWAR" },
  { district: "PAURI GARHWAL", udiseCode: "5060108104", schoolName: "GOVT. GIRLS INTER COLLEGE PAURI" },
  { district: "PAURI GARHWAL", udiseCode: "5061403304", schoolName: "GOVT. INTER COLLEGE BAGWARI" },
  { district: "PAURI GARHWAL", udiseCode: "5060801404", schoolName: "GOVT. INTER COLLEGE BALLI" },
  { district: "PAURI GARHWAL", udiseCode: "5060904402", schoolName: "GOVT. INTER COLLEGE BHIRGUKHAL" },
  { district: "PAURI GARHWAL", udiseCode: "5060609604", schoolName: "RAJEEV GANDHI NAVODAY VIDYALAY" },
  { district: "PITHORAGARH", udiseCode: "5070803015", schoolName: "G.G.IC. GANGOLIHAT" },
  { district: "PITHORAGARH", udiseCode: "5070608103", schoolName: "G.I.C. NACHANI" },
  { district: "PITHORAGARH", udiseCode: "5070705402", schoolName: "GGIC BERINAG" },
  { district: "PITHORAGARH", udiseCode: "5070513824", schoolName: "GGIC DHARCHULA" },
  { district: "PITHORAGARH", udiseCode: "5070817701", schoolName: "GIC  JHALTOLA" },
  { district: "PITHORAGARH", udiseCode: "5070702603", schoolName: "GIC  RAI AAGAR" },
  { district: "PITHORAGARH", udiseCode: "5070506602", schoolName: "GIC BARAM" },
  { district: "PITHORAGARH", udiseCode: "5070317102", schoolName: "GIC DEVAL THAL" },
  { district: "PITHORAGARH", udiseCode: "5070104504", schoolName: "KNU GIC PITHORAGARH" },
  { district: "PITHORAGARH", udiseCode: "5070604901", schoolName: "S.S.S.S.T.S.P. GIC MUNSYARI" },
  { district: "PITHORAGARH", udiseCode: "5070125106", schoolName: "SDS GIC PITHORAGARH" },
  { district: "RUDRAPRYAG", udiseCode: "5030109305", schoolName: "GIC CHOPTA" },
  { district: "RUDRAPRYAG", udiseCode: "5030309603", schoolName: "GIC GUPTKASHI" },
  { district: "RUDRAPRYAG", udiseCode: "5030203402", schoolName: "GIC PAUNTHI" },
  { district: "RUDRAPRYAG", udiseCode: "5030121304", schoolName: "GIC RATURA" },
  { district: "RUDRAPRYAG", udiseCode: "5030122106", schoolName: "GIC RUDRAPRAYAG" },
  { district: "TEHRI GARHWAL", udiseCode: "5040129201", schoolName: "GIC BALGANGA KEMRA" },
  { district: "TEHRI GARHWAL", udiseCode: "5040525402", schoolName: "GIC BHAWAN" },
  { district: "TEHRI GARHWAL", udiseCode: "5040105802", schoolName: "GIC CHAMIYALA" },
  { district: "TEHRI GARHWAL", udiseCode: "5040604704", schoolName: "GIC DANGCHORA" },
  { district: "TEHRI GARHWAL", udiseCode: "5040725502", schoolName: "GIC DHUDHAR" },
  { district: "TEHRI GARHWAL", udiseCode: "5040221602", schoolName: "GIC GAJA" },
  { district: "TEHRI GARHWAL", udiseCode: "5040401902", schoolName: "GIC JAKHNIDHAR" },
  { district: "TEHRI GARHWAL", udiseCode: "5040902902", schoolName: "GIC KAMAND" },
  { district: "TEHRI GARHWAL", udiseCode: "5040800602", schoolName: "GIC KANDIYALGAON" },
  { district: "TEHRI GARHWAL", udiseCode: "5040918302", schoolName: "GIC MAINDKHAL" },
  { district: "TEHRI GARHWAL", udiseCode: "5040327501", schoolName: "GIC PAURIKHAL" },
  { district: "TEHRI GARHWAL", udiseCode: "5040714202", schoolName: "GIC PAW KEE DEVI" },
  { district: "TEHRI GARHWAL", udiseCode: "5040115604", schoolName: "GIC POUKHAL" },
  { district: "TEHRI GARHWAL", udiseCode: "5040504601", schoolName: "GIC PUJARGAON" },
  { district: "TEHRI GARHWAL", udiseCode: "5040416503", schoolName: "GIC SEMANDIDHAR" },
  { district: "U.S.NAGAR", udiseCode: "5120307924", schoolName: "G.G.I.C. JASPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120107011", schoolName: "G.H.S.KULHA" },
  { district: "U.S.NAGAR", udiseCode: "5120107511", schoolName: "G.I.C. DINESHPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120107423", schoolName: "G.I.C. GADARPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120707328", schoolName: "GGIC BAZPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120505172", schoolName: "GGIC KASHIPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120609220", schoolName: "GGIC SITARGANJ" },
  { district: "U.S.NAGAR", udiseCode: "5120206501", schoolName: "GHS KICHA" },
  { district: "U.S.NAGAR", udiseCode: "5120502303", schoolName: "GIC  BANSKHERA" },
  { district: "U.S.NAGAR", udiseCode: "5120201749", schoolName: "GIC AN JHA RPR" },
  { district: "U.S.NAGAR", udiseCode: "5120606902", schoolName: "GIC AUDALI" },
  { district: "U.S.NAGAR", udiseCode: "5120200902", schoolName: "GIC BAGWALA" },
  { district: "U.S.NAGAR", udiseCode: "5120407203", schoolName: "GIC BANDIA" },
  { district: "U.S.NAGAR", udiseCode: "5120502202", schoolName: "GIC BARKHERI" },
  { district: "U.S.NAGAR", udiseCode: "5120609219", schoolName: "GIC SITARGANJ" },
  { district: "U.S.NAGAR", udiseCode: "5120707208", schoolName: "GIC SULTANPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120309401", schoolName: "GOVT H.S TIRATH NAGAR" },
  { district: "U.S.NAGAR", udiseCode: "5120704202", schoolName: "GOVT INTER COLLEGE BERIYA DAULAT" },
  { district: "U.S.NAGAR", udiseCode: "5120603306", schoolName: "GOVT INTER COLLEGE RUDPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120304403", schoolName: "GOVT.I.C.RAIPUR" },
  { district: "U.S.NAGAR", udiseCode: "5120404117", schoolName: "T.G.I.C. KHATIMA" },
  { district: "UTTARKASHI", udiseCode: "5010109223", schoolName: "GGIC  UTTARKASHI" },
  { district: "UTTARKASHI", udiseCode: "5010603707", schoolName: "GIC  PUROLA" },
  { district: "UTTARKASHI", udiseCode: "5010203208", schoolName: "GIC BANCHAURA" },
  { district: "UTTARKASHI", udiseCode: "5010205211", schoolName: "GIC CHINYALI SOUR" },
  { district: "UTTARKASHI", udiseCode: "5010309807", schoolName: "GIC DHONTRI" },
  { district: "UTTARKASHI", udiseCode: "5010512903", schoolName: "GIC KALOGI" },
  { district: "UTTARKASHI", udiseCode: "5010300703", schoolName: "GIC MAATLI" },
  { district: "UTTARKASHI", udiseCode: "5010410601", schoolName: "GIC MORI" },
  { district: "UTTARKASHI", udiseCode: "5010109226", schoolName: "GIC UTTARKASHI" },
];

export const districtSchoolCounts: Record<string, number> = {
  "ALMORA": 16,
  "BAGESHWAR": 7,
  "CHAMOLI": 15,
  "CHAMPAWAT": 7,
  "DEHRADUN": 9,
  "HARIDWAR": 14,
  "NAINITAL": 13,
  "PAURI GARHWAL": 6,
  "PITHORAGARH": 11,
  "RUDRAPRYAG": 5,
  "TEHRI GARHWAL": 15,
  "U.S.NAGAR": 21,
  "UTTARKASHI": 9,
};

export const totalSchoolCount = 148;